import { useCheckCommitFileVersion } from 'components/core/useCheckCommitFileVersion'
import { useFeatureFlags } from 'hooks/featureFlags'
import { useRouter } from 'hooks/router'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { NewVersionBannerContents } from './NewVersionBannerContents'

const intervalMS = 15 * 60 * 1000

export const NewVersionBannerWithKillSwitch = observer(
  function NewVersionBannerWithKillSwitch() {
    const ff = useFeatureFlags()
    const router = useRouter()
    const [dismissed, setDismissed] = useState(false)
    const { isOutdatedVersion } = useCheckCommitFileVersion({
      checkOnFocus: true,
      intervalMs: intervalMS,
    })
    const currentPage = router.currentRoute?.title

    useEffect(() => {
      if (!ff.serviceWorkerKillSwitch) return
      if (!('serviceWorker' in navigator)) return
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const reg of registrations) {
          reg.unregister()
        }
      })
    }, [ff.serviceWorkerKillSwitch])

    if (!isOutdatedVersion || dismissed) return null
    if (currentPage === 'meeting') return null
    if (currentPage === 'ltiLoaderPage') return null

    return (
      <NewVersionBannerContents
        onClickLater={() => {
          setDismissed(true)
        }}
        onClickRefresh={async () => {
          window.location.reload()
        }}
      />
    )
  }
)
